__turbopack_context__.v({
  "infoCloud": "InfoCloud-module-scss-module__ydZ0vq__infoCloud",
  "infoCloud__linkContentWrapper": "InfoCloud-module-scss-module__ydZ0vq__infoCloud__linkContentWrapper",
  "infoCloud__linkIcon": "InfoCloud-module-scss-module__ydZ0vq__infoCloud__linkIcon",
  "infoCloud__linkText": "InfoCloud-module-scss-module__ydZ0vq__infoCloud__linkText",
  "infoCloud__text": "InfoCloud-module-scss-module__ydZ0vq__infoCloud__text",
});
